// Step 22 — cross-buyer patterns filtered to this buyer.
//
// Reads `data.cross_buyer_patterns` from `getDealSituationLive` and
// only surfaces patterns that include the current buyer. Deterministic
// backend observation; we never invent additional analytics.

import { AIEmpty, AISection } from "../AIPrimitives";
import { crossPatternsForBuyer } from "./helpers";

export default function AIBuyerPatternsCard({ patterns, acquirerId }) {
  const matches = crossPatternsForBuyer(patterns, acquirerId);
  if (matches.length === 0) {
    return (
      <AISection title="Återkommande mönster">
        <AIEmpty
          title="Denna köpare ingår inte i något återkommande mönster"
          hint={
            "Mönster uppstår när minst två köpare har rest samma sak. " +
            "Text-matchning är exakt — subtilt olika formuleringar räknas inte."
          }
        />
      </AISection>
    );
  }
  return (
    <AISection title="Återkommande mönster (delade med andra köpare)">
      <ul className="qai-buyer-patterns-list">
        {matches.map((p, i) => (
          <li key={`${p.group}-${i}`} className="qai-buyer-pattern-row">
            <div className="qai-buyer-pattern-head">
              <span className="qai-finding-badge" data-tone="kind">
                {p.group_label}
              </span>
              <span className="qai-buyer-pattern-count">
                {p.acquirer_count} köpare totalt
              </span>
            </div>
            <div className="qai-buyer-pattern-text">"{p.normalized_text}"</div>
          </li>
        ))}
      </ul>
      <div className="qai-shell-empty-hint" style={{ marginTop: 8 }}>
        Deterministisk systemobservation — inga slutsatser läggs till.
      </div>
    </AISection>
  );
}
